export function yearsAgoMs(yearsAgo: number) {
  return Date.now() - yearsAgo * 365 * 24 * 60 * 60 * 1000;
}
